<template>
  <section-block>
    <template slot="header">
      <h2>In this section</h2>
    </template>
    <nav class="c-page-nav" v-if="links">
      <page-navigation-list :links="links"></page-navigation-list>
    </nav>
    <loading v-else></loading>
  </section-block>
</template>

<script>
import PageNavigationList from '@/components/PageNavigationList';

export default {
  name: 'page-navigation',

  components: {
    PageNavigationList,
  },

  props: {
    links: Array,
    currentPage: Object,
  },
};
</script>

<style lang="scss">
.c-page-nav {
  > ul {
    padding: 0;
  }
}
</style>
